import {LandingButtonLink} from '@app/components/landing-btn-link';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {useTranslation} from '@app/hooks/use-translation';
import {Image} from '@app/components/Image';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

export const IndexWorkoutSection = () => {
	const {t} = useTranslation();

	return (
		<LandingIllustrationSection
			imagePosition="left"
			description={
				<>
					<LandingHeading as="h2">
						{t('hubmomentslandingpage_title_workout_standalone-web', {
							ns: 'moments',
						})}
					</LandingHeading>
					<LandingParagraph>
						{t('hubmomentslandingpage_text_workout_standalone-web', {
							ns: 'moments',
						})}
					</LandingParagraph>
				</>
			}
			cta={
				<LandingButtonLink
					tracking={{eventaction: 'discover', eventlabel: 'workout'}}
					href={'/moments/workout'}
				>
					{t('generic_action_workoutmusic_standalone-web', {ns: 'common'})}
				</LandingButtonLink>
			}
			image={
				<Image
					sizes={{base: '100vw', md: '50vw'}}
					h={{base: '350px', md: '100%'}}
					src="fec3dbdd7b6862582f72566b85164d81.jpg"
					aspectRatio="867/577"
					alt={t('metatag_text_workoutwithmusic_standalone-web', {
						ns: 'common',
					})}
					quality={90}
				/>
			}
		/>
	);
};
